import React from "react";

const QuantitySelector = ({ quantity, className, isPDP = false, allowDecreaseToZero, onQuantityChange }) => {
    const handleDecreaseQuantity = () => {
        if (quantity > (allowDecreaseToZero ? 0 : 1)) onQuantityChange(quantity - 1, quantity);
    };

    const handleIncreaseQuantity = () => onQuantityChange(quantity + 1, quantity);

    return (
        <div
            className={`flex text-black w-full items-center select-none leading-4 p-2 text-sm font-medium mx-auto ${isPDP ? "max-w-[5.75rem] border-black border mb-0.5 rounded bg-white" : "max-w-[6.5rem] bg-[#E5EAED] rounded-md my-2.5"} ${className}`}
        >
            <button
                type="button"
                onClick={handleDecreaseQuantity}
                aria-label="Decrease Quantity by 1"
                className={`${isPDP ? "border-0 font-bold text-lg leading-4" : "border-r border-[#D2D3DC]"} cursor-pointer py-0.5 pr-2`}
            >
                -
            </button>
            <input
                className={`inline-block w-full border-0 bg-transparent text-small text-center focus-visible:outline-0 ${isPDP && "w-7/12 text-base"}`}
                aria-label="Current Quantity"
                readOnly
                value={quantity}
            />
            <button
                type="button"
                className={`${isPDP ? "border-0 font-bold text-lg leading-4" : "border-l border-[#D2D3DC]"} cursor-pointer py-0.5 pl-2`}
                onClick={handleIncreaseQuantity}
                aria-label="Increase Quantity by 1"
            >
                +
            </button>
        </div>
    );
};

export default QuantitySelector;
